<template>
	<section>
		<slot
			:events="events"
			:active-event="activeEvent"
			:set-active-event="setActiveEvent"
		/>
	</section>
</template>

<script>
/* eslint-disable */
const lookup = require('country-data-list').lookup;
const getParams = url => {
	const params = {};
	const parser = document.createElement('a');
	parser.href = url;
	const query = parser.search.substring(1);
	const vars = query.split('&');
	for (let i = 0; i < vars.length; i++) {
		const pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

import moment from 'moment';

export default {
	props: {
		artists: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			events: [],
			activeEvent: null,
		};
	},
	watch: {
		activeEvent(event) {
			if (event) {
				this.$nextTick(() =>
					document.getElementById('activeEvent').scrollIntoView({ behavior: 'smooth' })
				);
			}
		},
	},
	async mounted() {
		if (getParams(window.location.href)['no-events']) {
			this.events = [];
			return;
		}
		this.events = (
			await Promise.all(
				(
					await Promise.all(
						this.artists.map(artist => {
							return window.fetch(
								`https://rest.bandsintown.com/artists/${encodeURIComponent(
									artist
								)}/events/?app_id=e397bc9093aa5c36b3a9ca75a84d1b09`
							);
						})
					)
				).map(response => response.json())
			)
		)
			.flat()
			.sort(({ datetime: a }, { datetime: b }) => (a < b ? -1 : a > b ? 1 : 0))
			.filter(({ artist_id }) => artist_id === '3256') // Amanda Palmer
			// .filter(({ artist_id }) => artist_id === '403') // Dresden Dolls
			.map(event => {
				const displayDate = moment(event.datetime).format('MMM D, YYYY');
				return {
					...event,
					displayDate,
					country: lookup.countries({ name: event.venue.country })[0],
					mapOptions: {
						disableDefaultUI: true,
						center: { lat: Number(event.venue.latitude), lng: Number(event.venue.longitude) },
						styles: [
							{
								elementType: 'geometry',
								stylers: [
									{
										color: '#212121',
									},
								],
							},
							{
								elementType: 'labels.icon',
								stylers: [
									{
										visibility: 'off',
									},
								],
							},
							{
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#757575',
									},
								],
							},
							{
								elementType: 'labels.text.stroke',
								stylers: [
									{
										color: '#212121',
									},
								],
							},
							{
								featureType: 'administrative',
								elementType: 'geometry',
								stylers: [
									{
										color: '#757575',
									},
								],
							},
							{
								featureType: 'administrative.country',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#9e9e9e',
									},
								],
							},
							{
								featureType: 'administrative.land_parcel',
								stylers: [
									{
										visibility: 'off',
									},
								],
							},
							{
								featureType: 'administrative.locality',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#bdbdbd',
									},
								],
							},
							{
								featureType: 'poi',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#757575',
									},
								],
							},
							{
								featureType: 'poi.park',
								elementType: 'geometry',
								stylers: [
									{
										color: '#181818',
									},
								],
							},
							{
								featureType: 'poi.park',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#616161',
									},
								],
							},
							{
								featureType: 'poi.park',
								elementType: 'labels.text.stroke',
								stylers: [
									{
										color: '#1b1b1b',
									},
								],
							},
							{
								featureType: 'road',
								elementType: 'geometry.fill',
								stylers: [
									{
										color: '#2c2c2c',
									},
								],
							},
							{
								featureType: 'road',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#8a8a8a',
									},
								],
							},
							{
								featureType: 'road.arterial',
								elementType: 'geometry',
								stylers: [
									{
										color: '#373737',
									},
								],
							},
							{
								featureType: 'road.highway',
								elementType: 'geometry',
								stylers: [
									{
										color: '#3c3c3c',
									},
								],
							},
							{
								featureType: 'road.highway.controlled_access',
								elementType: 'geometry',
								stylers: [
									{
										color: '#4e4e4e',
									},
								],
							},
							{
								featureType: 'road.local',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#616161',
									},
								],
							},
							{
								featureType: 'transit',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#757575',
									},
								],
							},
							{
								featureType: 'water',
								elementType: 'geometry',
								stylers: [
									{
										color: '#000000',
									},
								],
							},
							{
								featureType: 'water',
								elementType: 'labels.text.fill',
								stylers: [
									{
										color: '#3d3d3d',
									},
								],
							},
						],
					},
				};
			});
	},
	methods: {
		setActiveEvent(event) {
			this.activeEvent = event;
		},
	},
};
</script>
